import api from './index';

let exports = {};
//
// 分页查询
exports.getServStaffScorePageList = function (data, callback) {
    api.post('/servicer/score/staff/score/page/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};


export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/servicerStaffScore.js
// module id = 1421
// module chunks = 1